<template>
  <div style="background: white">
    <EducationHeader />
    <div class="breadBox">
      <a-breadcrumb>
        <span>
          <img src="@/assets/img/position.png" />
          当前位置：
        </span>
        <a-breadcrumb-item @click="onRollbackHome" style="cursor:pointer">首页</a-breadcrumb-item>
        <a-breadcrumb-item @click="onBackLevel" style="cursor:pointer">找人才</a-breadcrumb-item>
        <a-breadcrumb-item>找人才详情</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="tutorBox">
      <div class="rightBox">
        <div class="tankName">{{ peopleDetail.title }}</div>
        <div class="infoBox">
          <p>咨询电话：{{ peopleDetail.telephone }}</p>
          <p>报名时间：{{ peopleDetail.startDate }} ~ {{ peopleDetail.endDate }}</p>
          <p>报名地址：{{ peopleDetail.webAddress }}</p>
        </div>
      </div>
    </div>
    <div class="talentBox">
      <div class="talentLeftBox">
        <div class="talentTitleBox">
          <div class="talentTitle">
            岗位描述
          </div>
        </div>
        <div class="talentContentBox">
          <div class="tutorText" v-html="peopleDetail.recruitmentContent"></div>
        </div>
      </div>
      <div class="talentRightBox">
        <div class="talentTitleBox">
          <div class="talentTitle">
            招聘岗位及人数
          </div>
        </div>
        <div class="talentContentBox">
          <div class="card" v-for="item in peopleDetail.talentJobOpeningsList" :key="item.id">
            <div class="info">
              <p style="margin-bottom: 15px;font-size: 16px;color: #333;font-weight: bold;">{{ item.jobTitle }}</p>
              <p>专业：<dict-render :dict-obj="dictObjs['education_major']" v-if="item.major" :text="item.major"></dict-render></p>
              <p>学历：<dict-render :dict-obj="dictObjs['education_background']" v-if="item.educationBackground" :text="item.educationBackground"></dict-render></p>
              <p>年龄：<dict-render :dict-obj="dictObjs['age_ranger']" v-if="item.age" :text="item.age"></dict-render></p>
              <p style="margin: 10px 0 0 0"><span style="font-size:30px;color: #ff9000;">{{ item.numberPeople }}</span>人</p>
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <LayoutFooter />
  </div>
</template>
<script>
import { dictMixin } from "@/mixins";
import EducationHeader from './educationHeader';
import { homeEducationInfo } from "@/api/educationService";
import DictRender from '@/components/other/DictRender';
import { file_service } from "@/api/adminService";
import LayoutFooter from '@/layout/layoutPage/footer/LayoutFooterNew2';

export default {
  name: "findpeopleDetail",
  components: { EducationHeader, DictRender, LayoutFooter },
  mixins: [dictMixin],
  data() {
    return {
      dictNames: 'education_background,professionalTitle,research_field,education_major,age_ranger',
      peopleDetail: {}
    }
  },
  methods: {
    getDetail() {
      this.getAction({
        url: homeEducationInfo.findpeopleDetail,
        params: { id: this.$route.query.id }
      }).then(res => {
        let obj = {
          ...res,
        }
        this.peopleDetail = obj
      })
    },
    onBackLevel() {
      this.$router.push({
        path: "/educationService/components/findpeople",
        query: { type: '找人才' }
      })
    },
    onRollbackHome() {
      this.$router.push({
        path: "/educationService/index",
        query: { type: '首页' }
      })
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
  },
  mounted() {
    this.getDetail()
  }
}
</script>
<style lang="less" scoped>
.breadBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  background: white;
}

.tutorBox {
  width: 1200px;
  margin: 0 auto;

  .rightBox {
    padding: 15px;
    border: 1px solid #dedede;

    .tankName {
      margin-bottom: 15px;
      font-size: 18px;
      color: #333;
    }

    .infoBox {
      font-size: 14px;
      color: #666;

      p {
        margin: 10px 0;
      }
    }
  }
}

.talentBox {
  overflow: hidden;
  width: 1200px;
  margin: 20px auto;

  .talentLeftBox {
    float: left;
    width: 70%;

    .talentTitleBox {
      overflow: hidden;
      width: 100%;
      padding: 15px 0 8px 0;
      border-bottom: 1px solid #dedede;

      .talentTitle {
        float: left;
        font-size: 20px;
        color: #333;
      }

      .talentTitle::before {
        content: '';
        padding-left: 12px;
        border-left: 4px solid #035aea;
      }
    }

    .talentContentBox {
      padding: 14px 0;
      width: 100%;

      .tutorText {
        font-size: 14px;
        color: #333;
        text-indent: 2em;
      }

      .zhuanjiaBox {
        width: 1200px;
        margin: 0 auto;
        padding: 20px;
        border-bottom: 1px dashed #dedede;

        .tutorName {
          margin-bottom: 10px;
          font-size: 16px;
          color: #333;
        }

        .grayBox {
          margin-bottom: 10px;
          font-size: 14px;
          color: #999;
        }

        .jianjie {
          text-indent: 2em;
          font-size: 14px;
          color: #333;
        }
      }
    }
  }
  .talentRightBox {
    float: right;
    width: 28%;

    .talentTitleBox {
      overflow: hidden;
      width: 100%;
      padding: 15px 0 8px 0;
      border-bottom: 1px solid #dedede;

      .talentTitle {
        float: left;
        font-size: 20px;
        color: #333;
      }

      .talentTitle::before {
        content: '';
        padding-left: 12px;
        border-left: 4px solid #035aea;
      }
    }

    .talentContentBox {
      padding: 14px 0;
      width: 100%;
      .card{
        border: 1px solid #dedede;
        padding: 15px 10px;

        .info{
          font-size: 14px;
          color: #999;
        }
      }
    }
  }
}

:deep(.ant-descriptions-item) {
  padding-bottom: 6px;
}

:deep(.ant-descriptions-item-label) {
  font-size: 14px;
  color: #999;
}

:deep(.ant-descriptions-item-content) {
  font-size: 14px;
  color: #999;
}
</style>
